/* Maßanfertigung: integrierte Mengenpreise im regulären Shopify-Warenkorb (echte Stückzahl, Stückpreis × Menge). */
(function () {
  'use strict';
  // Anzeigetexte je Seitensprache (shop.dipos.eu = en); Daten wie Optionswerte und Warenkorb-Eigenschaften bleiben deutsch.
  const TEXTS = {
    de: {
      shape: 'Bitte eine Form auswählen.',
      quantity: 'Bitte 1 bis 1.000 ganze Stück eingeben.',
      dimensions: 'Bitte gültige Maße eingeben.',
      radius: 'Der Eckenradius darf höchstens die halbe kürzere Seite betragen.',
      format: 'Für dieses Format schreib uns bitte eine E-Mail an info@dipos.de.',
      privacyFormat: 'Blickschutzfolie 4way ist bis 594 × 420 mm erhältlich (Kreis: maximal 420 mm Durchmesser).',
      lineQuantity: 'Bitte 1 bis 1.000 ganze Stück je Konfiguration eingeben.',
      itemPrice: 'Der Artikelpreis konnte nicht ermittelt werden. Bitte die Seite neu laden.',
      cartUpdate: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte erneut versuchen.',
      cartChanged: 'Der Warenkorb wurde geändert. Bitte lade die Seite neu.',
      priceUpdating: 'Der Preis wird gerade aktualisiert. Bitte lade den Warenkorb neu und versuche es erneut.',
      unavailable: 'Diese Kombination ist derzeit nicht verfügbar.',
      perUnit: 'je Folie',
      summary: (quantity, total) => `${quantity} Stück · Gesamtpreis ${total}`,
      pricePending: 'Der Preis erscheint nach Eingabe gültiger Maße.',
      adding: 'Wird hinzugefügt …',
      addToCart: 'In den Warenkorb'
    },
    en: {
      shape: 'Please select a shape.',
      quantity: 'Please enter a whole number from 1 to 1,000.',
      dimensions: 'Please enter valid dimensions.',
      radius: 'The corner radius may be at most half of the shorter side.',
      format: 'Please request this size by email (info@dipos.de).',
      privacyFormat: 'The 4-way privacy protector is available up to 594 × 420 mm (circle: maximum diameter 420 mm).',
      lineQuantity: 'Please enter a whole number from 1 to 1,000 per configuration.',
      itemPrice: 'The item price could not be determined. Please reload the page.',
      cartUpdate: 'The cart could not be updated. Please try again.',
      cartChanged: 'Your cart has changed. Please reload the page.',
      priceUpdating: 'The price is being updated. Please reload the cart and try again.',
      unavailable: 'This combination is currently not available.',
      perUnit: 'per protector',
      summary: (quantity, total) => `${quantity} pcs · total ${total}`,
      pricePending: 'The price appears once you enter valid dimensions.',
      adding: 'Adding …',
      addToCart: 'Add to cart'
    }
  };
  const T = TEXTS[typeof document !== 'undefined' && /^en/i.test(document.documentElement.lang) ? 'en' : 'de'];
  const tiers = [[98, 210], [148, 210], [210, 297], [297, 420], [420, 594], [700, 1000]];
  const largeFormatIndex = 5;
  const largeFormatFeeCents = 3500;
  function sizeClass(values) {
    const circle = values.shape === 'Kreis';
    if (!circle && values.shape !== 'Rechteck') throw new Error(T.shape);
    const width = Number(circle ? values.diameter : values.width);
    const height = Number(circle ? values.diameter : values.height);
    const quantity = Number(values.quantity);
    const radius = circle ? 0 : Number(values.radius);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 1000) throw new Error(T.quantity);
    if (![width, height].every(n => Number.isFinite(n) && n >= 5)) throw new Error(T.dimensions);
    if (!Number.isFinite(radius) || radius < 0 || radius > Math.min(width, height) / 2) throw new Error(T.radius);
    const index = tiers.findIndex(([short, long]) => Math.min(width, height) <= short && Math.max(width, height) <= long);
    if (index < 0) throw new Error(T.format);
    return { index, width, height, radius, quantity };
  }
  // Stückpreis auf Cent gerundet; der Positionspreis ist immer Stückpreis × Menge.
  function unitPrice(basePrice, quantity, feeShare) {
    return Math.round((basePrice * quantity + feeShare) / quantity);
  }
  // Fertigungsbezeichnung für die JTL-Position; Eigenschaftswerte sind deutsche Daten („80 mm“).
  function fertigung(properties) {
    const mm = key => String(properties[key] || '').replace(/\s*mm$/, '').replace('.', ',');
    const material = /^dipos /.test(properties.Material) ? properties.Material : `dipos ${properties.Material}`;
    const zusatz = 'inkl. integrierter Abziehlasche, Retailverpackung';
    if (properties.Form === 'Kreis') return `${material}, kreisrund gelasert, ${mm('Durchmesser')} mm Durchmesser, ${zusatz}`;
    return `${material}, rechteckig gelasert, ${mm('Breite')} x ${mm('Länge')} mm, Eckenradius ${mm('Eckenradius')} mm, ${zusatz}`;
  }
  // Die Preis-App gibt nur die Werte aus __ooCalcPayload an die Bestellposition weiter (→ JTL-Positionshinweis).
  function calcPayload(properties) {
    const payload = { Fertigung: fertigung(properties) };
    ['Material', 'Form', 'Breite', 'Länge', 'Eckenradius', 'Durchmesser'].forEach(key => {
      if (properties[key]) payload[key] = properties[key];
    });
    return JSON.stringify(payload);
  }
  // Stückgrundpreis der Größenklasse; die Klasse ergibt sich aus den bestellten Maßen, nicht aus der Variante.
  function basePrice(variant, dimensions) {
    const large = dimensions.index === largeFormatIndex;
    if (large && /4way/i.test(variant?.material || '')) throw new Error(T.privacyFormat);
    const price = variant?.prices?.[large ? 4 : dimensions.index];
    if (!Number.isInteger(price) || price <= 0) throw new Error(T.itemPrice);
    return large ? Math.round(price * Math.max(1, dimensions.width * dimensions.height / (420 * 594))) : price;
  }
  function lineDimensions(properties = {}) {
    const mm = key => String(properties[key] ?? '').replace(/\s*mm$/, '');
    return sizeClass({ shape: properties.Form, width: mm('Breite'), height: mm('Länge'), diameter: mm('Durchmesser'), radius: mm('Eckenradius') || 0, quantity: 1 });
  }
  function lineClass(properties = {}) {
    return lineDimensions(properties).index;
  }
  function orderFee(dimensions, feeCents) {
    return dimensions.index === largeFormatIndex ? largeFormatFeeCents : feeCents;
  }
  function pricePlan(items, variants, productId, feeId, feeCents = 1000) {
    const lines = items.filter(item => String(item.product_id) === String(productId)).map(item => {
      const quantity = item.properties?._massanfertigung === 'v2' ? Number(item.properties['Stückzahl']) * item.quantity : item.quantity;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 1000) throw new Error(T.lineQuantity);
      const variant = variants.find(v => String(v.id) === String(item.variant_id));
      let price, dimensions;
      try {
        dimensions = lineDimensions(item.properties);
        price = basePrice(variant, dimensions);
      } catch { throw new Error(T.itemPrice); }
      return { item, quantity, price, dimensions };
    });
    // Sobald ein Großformat enthalten ist, gilt der höhere Anteil einmal für den gesamten Auftrag.
    const fee = lines.some(line => line.dimensions.index === largeFormatIndex) ? largeFormatFeeCents : feeCents;
    const count = lines.reduce((sum, line) => sum + line.quantity, 0);
    let allocated = 0;
    let processed = 0;
    return {
      remove: items.filter(item => String(item.variant_id) === String(feeId)).map(item => item.key),
      lines: lines.map(({ item, quantity, price }) => {
        processed += quantity;
        const cumulative = Math.round(fee * processed / count);
        const unit = unitPrice(price, quantity, cumulative - allocated);
        allocated = cumulative;
        return { key: item.key, quantity, unit, price: unit * quantity, identity: item.properties?._mass_id || `bestand-${item.key}` };
      })
    };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { sizeClass, pricePlan, unitPrice, fertigung, calcPayload, lineClass, basePrice, orderFee };
    return;
  }
  const setup = document.getElementById('massanfertigung-cart-config');
  if (!setup) return;
  const config = JSON.parse(setup.textContent);
  let customCart = config.hasCustom || config.hasFee;
  const root = window.Shopify.routes.root;
  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: config.currency }).format(cents / 100);
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : { cache: 'no-store' });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || T.cartUpdate);
    return data;
  }
  let pending = Promise.resolve();
  function reconcile(change) {
    const run = pending.catch(() => {}).then(async () => {
      let cart = await request('cart.js');
      let changed = false;
      if (change) {
        const item = cart.items.find(item => item.key === change.key);
        if (!item) throw new Error(T.cartChanged);
        if (item.properties?._massanfertigung === 'v2') {
          const properties = { ...item.properties, 'Stückzahl': String(change.quantity) };
          cart = await request('cart/change.js', { id: item.key, quantity: change.quantity === 0 ? 0 : 1, properties });
        } else cart = await request('cart/change.js', { id: item.key, quantity: change.quantity });
        changed = true;
      }
      customCart = cart.items.some(item => String(item.product_id) === String(config.productId) || String(item.variant_id) === String(config.feeId));
      const plan = pricePlan(cart.items, config.variants, config.productId, config.feeId, config.feeCents);
      if (plan.remove.length) {
        cart = await request('cart/update.js', { updates: Object.fromEntries(plan.remove.map(key => [key, 0])) });
        changed = true;
      }
      for (const line of plan.lines) {
        const item = cart.items.find(item => item.properties?._mass_id === line.identity || item.key === line.key);
        if (!item) throw new Error(T.cartChanged);
        const properties = { ...item.properties, _massanfertigung: 'v3', _mass_id: line.identity,
          __ooCustomPrice: (line.unit / 100).toFixed(2) };
        // Alte App-Angebote dürfen den neu berechneten Preis nicht überschreiben; v2-Mengenangaben entfallen.
        ['__ooLiteSig', '__ooDraftToken', '__ooQuotedPrice', '__ooPayloadHash', '__ooSkipCartTransform', 'Stückzahl', 'Stückpreis'].forEach(key => delete properties[key]);
        properties.__ooCalcPayload = calcPayload(properties);
        if (item.quantity !== line.quantity || Object.keys(item.properties || {}).length !== Object.keys(properties).length || Object.entries(properties).some(([key, value]) => item.properties?.[key] !== value)) {
          cart = await request('cart/change.js', { id: item.key, quantity: line.quantity, properties });
          changed = true;
        }
      }
      // Die App muss die Preise tatsächlich in Shopify übernommen haben.
      for (const line of plan.lines) {
        const item = cart.items.find(item => item.properties?._mass_id === line.identity);
        if (!item || item.final_line_price !== line.price) throw new Error(T.priceUpdating);
      }
      return { cart, changed };
    });
    pending = run;
    return run;
  }
  function showCartError(error) {
    let message = document.getElementById('massanfertigung-cart-error');
    if (!message) {
      message = document.createElement('p');
      message.id = 'massanfertigung-cart-error';
      message.setAttribute('role', 'alert');
      (document.querySelector('.cart__ctas') || document.querySelector('main')).append(message);
    }
    message.textContent = error.message;
  }
  function initForm() {
    const form = document.getElementById('massanfertigung-form');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const variants = JSON.parse(document.getElementById('massanfertigung-variants').textContent);
    const error = form.querySelector('[data-error]');
    const total = form.querySelector('[data-total]');
    const button = form.querySelector('[type="submit"]');
    function selection() {
      const values = Object.fromEntries(new FormData(form));
      const dimensions = sizeClass(values);
      const variant = variants.find(v => v.material === values.material && v.shape === values.shape && v.available);
      if (!variant) throw new Error(T.unavailable);
      return { values, dimensions, variant, price: basePrice(variant, dimensions) };
    }
    function update() {
      form.querySelector('[data-rolled-delivery]').hidden = true;
      const circle = form.elements.shape.value === 'Kreis';
      form.querySelectorAll('[data-rectangle], [data-circle]').forEach(group => {
        const hidden = group.hasAttribute('data-circle') !== circle;
        group.hidden = hidden;
        group.querySelectorAll('input').forEach(input => { input.disabled = hidden; });
      });
      try {
        const measures = circle ? [form.elements.diameter] : [form.elements.width, form.elements.height];
        if (measures.some(input => !input.value)) throw new Error('');
        const { dimensions, price } = selection();
        const unit = unitPrice(price, dimensions.quantity, orderFee(dimensions, config.feeCents));
        form.querySelector('[data-rolled-delivery]').hidden = dimensions.index !== largeFormatIndex;
        total.textContent = `${money(unit)} ${T.perUnit}`;
        form.querySelector('[data-average]').textContent = T.summary(dimensions.quantity, money(unit * dimensions.quantity));
        error.textContent = '';
        button.disabled = false;
      } catch (problem) {
        error.textContent = problem.message;
        total.textContent = T.pricePending;
        form.querySelector('[data-average]').textContent = '';
        button.disabled = true;
      }
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || !form.reportValidity()) return;
      let added = false;
      try {
        const { values, dimensions, variant, price } = selection();
        button.disabled = true;
        button.textContent = T.adding;
        const properties = { Material: values.material, Form: values.shape };
        if (values.shape === 'Kreis') properties['Durchmesser'] = `${dimensions.width} mm`;
        else {
          properties['Breite'] = `${dimensions.width} mm`;
          properties['Länge'] = `${dimensions.height} mm`;
          properties['Eckenradius'] = `${dimensions.radius} mm`;
        }
        properties['_massanfertigung'] = 'v3';
        properties['_mass_id'] = crypto.randomUUID();
        properties['__ooCustomPrice'] = (unitPrice(price, dimensions.quantity, orderFee(dimensions, config.feeCents)) / 100).toFixed(2);
        properties['__ooCalcPayload'] = calcPayload(properties);
        await request('cart/add.js', { items: [{ id: variant.id, quantity: dimensions.quantity, properties }] });
        added = true;
        await reconcile();
        window.location.assign(root + 'cart');
      } catch (problem) {
        if (added) {
          window.location.assign(root + 'cart');
          return;
        }
        error.textContent = problem.message;
        button.disabled = false;
        button.textContent = T.addToCart;
      }
    });
    update();
  }
  let checkingOut = false;
  async function checkout(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    try {
      await reconcile();
      window.location.assign(root + 'checkout');
    } catch (problem) {
      checkingOut = false;
      showCartError(problem);
    }
  }
  document.addEventListener('click', event => {
    if (customCart && event.target.closest('[name="checkout"], a[href="/checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (customCart && event.submitter?.name === 'checkout') checkout(event);
  }, true);
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-mass-quantity]');
    if (!input) return;
    event.stopImmediatePropagation();
    const quantity = Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > 1000) {
      showCartError(new Error(T.quantity));
      return;
    }
    input.disabled = true;
    try {
      await reconcile({ key: input.dataset.massQuantity, quantity });
      window.location.reload();
    } catch (problem) { input.disabled = false; showCartError(problem); }
  }, true);
  function init() {
    initForm();
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, async event => {
      if (event.source === 'massanfertigung') return;
      if (!customCart && !event.cartData?.items?.some(item => String(item.product_id) === String(config.productId) || String(item.variant_id) === String(config.feeId))) return;
      try {
        const result = await reconcile();
        if (result.changed) {
          if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) window.location.reload();
          else publish(PUB_SUB_EVENTS.cartUpdate, { source: 'massanfertigung', cartData: result.cart });
        }
      } catch (problem) { showCartError(problem); }
    });
    if (config.hasCustom || config.hasFee) reconcile().then(result => {
      if (result.changed && window.location.pathname.replace(/\/$/, '').endsWith('/cart')) window.location.reload();
    }).catch(showCartError);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
